import { Divider, LinearProgress, SelectChangeEvent, CircularProgress, Grid, Theme, Typography, Box } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, FormikProps, validateYupSchema, yupToFormErrors } from '../../lib/formik/Formik';
import { Applicant, GetDataForKycModificationResponseBody, KycDetails, MfuKycModificationResponseBody, MfuKycOnboardingResponseBody, FamilyListObj, GetFamilyListResponseBody, uboTypes } from '../../redux-store/types/api-types';
import { FAMILY_MAPPING_TYPE, grossAnnualMasters, investorTypeMasters, PEPsMasters, USER_ROLES } from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useRef, useState } from 'react';
import {
  applicationComparison,
  currencyConversion,
  getUniqueIdentityText,
  isModuleAllowed,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { getUboTypes } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions/mdms';
import dayjs from '../../utils/dayjs';
import { CountryCodesDropDown } from '../commonComponents';
import { LoadingButton } from '@mui/lab';
import { getDataForKycModification, MfuKycModification } from '../../redux-store/actions/onBoarding';
import KycEditPopup from '../onboarding/KycEditPopup';
import KycInfoPopup from '../onboarding/KycInfoPopup';
import { getFamilyList } from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';
import MFCheckbox from '../../lib/formik/Checkbox';
import UseRadioGroup from '../../lib/formik/Radio';

const contributorObject: Partial<Applicant> = {
  name: '',
  countryOfIncorporation: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  amlCheck: undefined,
  kraVerified: '',
  kraMobileNumber: '',
  kraEmailId: '',
  grossAnnualIncome: '',
  netWorth: '',
  netWorthDate: '',
  politicallyExposedPersonStatus: '',
  gstRegNo: '',
  cin: ''
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<Applicant>[];
  familyMappingType: string;
  familyId: string;
  familyName: string;
  isHeadOfFamily: boolean;
  ubo_declaration_type: string;
  ubo_declaration_value: string;
  ubo_declaration_others_value: string;
};

const familyMappingOptions = [
  { label: "Choose existing family", value: FAMILY_MAPPING_TYPE.EXISTING },
  { label: "Add new family", value: FAMILY_MAPPING_TYPE.NEW }
]

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  familyMappingType: FAMILY_MAPPING_TYPE.EXISTING,
  familyId: "",
  familyName: "",
  isHeadOfFamily: false,
  ubo_declaration_type: '',
  ubo_declaration_value: '',
  ubo_declaration_others_value: '',
};

type mdmsCountriesList = {
  name: string;
  dial_code: string;
  code: string;
  nationality: string;
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { locale } = useSelector((store: RootStateType) => store.currencyInfo);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [isEditKycLoading, setEditKycLoading] = useState<boolean>(false)
  const [kycData, setKycData] = useState<KycDetails & {
    isNameChecked: boolean;
    isEmailChecked: boolean;
    isMobileChecked: boolean;
    isAddressChecked: boolean;
  } | null>(null)
  const [selectedApplicantId, setSelectedApplicantId] = useState<number | null>(null)
  const [isKycEditPopupOpen, setKycEditPopupOpen] = useState<boolean>(false)
  const [kycLinkLoading, setKycLinkLoading] = useState<boolean>(false)
  const [kycLinkData, setKycLinkData] = useState<MfuKycOnboardingResponseBody | null>(null)
  const [kycLinkPopupOpen, setKycLinkPopupOpen] = useState<boolean>(false)
  const [familyListData, setFamilyListData] = useState<
    Array<{
      key: string;
      value: string;
    }>
  >([])
  const [isFamilyListDataLoading, setFamilyListDataLoading] = useState<boolean>(false)
  const [uboTypesMdms, setUboTypesMdms] = useState<uboTypes | null>(null)

  const formikRef = useRef<FormikProps<Values>>(null);

  const isDigitalOnboarding = `${application?.onboardingVia ?? ""}`.toLowerCase() === "digital"

  const fetchFamilyListData = async () => {
    try {
      setFamilyListDataLoading(true)

      const response = await (dispatch(getFamilyList()) as unknown as Promise<GetFamilyListResponseBody>)

      if (!response?.isSuccess) {
        dispatch(showError(response?.message ?? ""))
        return
      }

      if (response?.isSuccess) {
        const modifiedFamilyListData = (response?.familyList ?? []).map((obj: FamilyListObj) => ({
          key: obj?.familyName ?? "",
          value: obj?.familyId ?? ""
        }))

        setFamilyListData(modifiedFamilyListData)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setFamilyListDataLoading(false)
    }
  }

  useEffect(() => {
    fetchFamilyListData()
  }, [])

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getUboTypes())) as unknown as uboTypes;
        setUboTypesMdms(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      try {
        const {
          applicants = [],
          familyId = "",
          familyName = "",
          isHeadOfFamily = "",
          ubo_declaration_type = '',
          ubo_declaration_value = '',
        } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);

        // Determine UBO declaration others value
        let ubo_declaration_others_value = '';
        if (ubo_declaration_value && uboTypesMdms) {
          uboTypesMdms.uboType.forEach((type) => {
            if (type.key === ubo_declaration_type && type.displayOthers) {
              const found = type.values.filter((v) => v.key === ubo_declaration_value).length;
              if (!found) {
                ubo_declaration_others_value = ubo_declaration_value;
              }
            }
          });
        }

        // Determine the correct ubo_declaration_value for form display
        let displayDeclarationValue = ubo_declaration_value;
        if (ubo_declaration_value && uboTypesMdms) {
          uboTypesMdms.uboType.forEach((type) => {
            if (type.key === ubo_declaration_type && type.displayOthers) {
              const found = type.values.filter((v) => v.key === ubo_declaration_value).length;
              if (!found) {
                displayDeclarationValue = `${ubo_declaration_type}_others`;
              }
            }
          });
        }

        setContributorValues({
          ...contributorValues,
          familyId: familyId ?? "",
          familyName: familyName ?? "",
          isHeadOfFamily: isHeadOfFamily === "Y",
          familyMappingType: familyId ? FAMILY_MAPPING_TYPE.EXISTING : (familyName ? FAMILY_MAPPING_TYPE.NEW : FAMILY_MAPPING_TYPE.EXISTING),
          applicants: applicants.length ? applicants : [contributorObject],
          ubo_declaration_type: ubo_declaration_type ?? '',
          ubo_declaration_value: displayDeclarationValue ?? '',
          ubo_declaration_others_value: ubo_declaration_others_value ?? '',
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application, uboTypesMdms]);

  const handleApplicant = async (values: Omit<Values, "familyMappingType">) => {
    const { saveType, applicants = [], familyId = "", familyName = "", isHeadOfFamily = "", ubo_declaration_type = '', ubo_declaration_value = '', ubo_declaration_others_value = '' } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
            application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
              ...bank,
              pennydropCheck: false,
              pennydropVerified: false,
            })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
        familyId: familyId ?? "",
        familyName: familyName ?? "",
        isHeadOfFamily: isHeadOfFamily ? "Y" : "N",
        ubo_declaration_type: ubo_declaration_type ?? '',
        ubo_declaration_value: ubo_declaration_value === `${ubo_declaration_type}_others`
          ? removeSingleQuote(ubo_declaration_others_value)
          : removeSingleQuote(ubo_declaration_value),
      }
    );

    let currentStatus = application?.status

    if (
      !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
      application?.status === 'sent_to_amc_approver'
    ) {
      currentStatus = 'draft'
    }

    if (id && !checkApplication) {
      return await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
                application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                  ...bank,
                  pennydropCheck: false,
                  pennydropVerified: false,
                })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              netWorthDate: applicant.netWorthDate ? dayjs(applicant.netWorthDate).format("YYYY-MM-DD") : null
            })),
            modeOfHolding: 'single',
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
            status: currentStatus,
            familyId: familyId ?? "",
            familyName: familyName ?? "",
            isHeadOfFamily: isHeadOfFamily ? "Y" : "N",
            ubo_declaration_type: ubo_declaration_type ?? '',
            ubo_declaration_value: ubo_declaration_value === `${ubo_declaration_type}_others`
              ? removeSingleQuote(ubo_declaration_others_value)
              : removeSingleQuote(ubo_declaration_value),
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    }
    return true;
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { familyMappingType, ...modifiedValues } = values
      const { saveType, ubo_declaration_type, ubo_declaration_value, ubo_declaration_others_value } = modifiedValues;

      // UBO Declaration validation (same as UBO section)
      if (saveType === 'save and proceed') {
        if (!ubo_declaration_type) {
          throw 'Please Select UBO Declaration Type';
        }
        if (!ubo_declaration_value) {
          throw 'Please Select UBO Declaration value';
        }
        if (
          ubo_declaration_value === `${ubo_declaration_type}_others` &&
          !ubo_declaration_others_value
        ) {
          throw 'Please Specify Others in UBO';
        }
      }

      const res = await handleApplicant(modifiedValues)
      if (!res) return;
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      typeof e === 'string'
        ? dispatch(showError(e))
        : console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditKycClick = async ({
    applicationId,
    applicantId,
    panNo
  }: {
    applicationId: string;
    applicantId: string;
    panNo: string;
  }) => {
    try {
      setEditKycLoading(true)

      const payload = {
        applicationId: Number(applicationId ?? ""),
        applicantId: Number(applicantId ?? ""),
        panNo
      }

      const response = await (dispatch(getDataForKycModification(payload)) as unknown as Promise<GetDataForKycModificationResponseBody>)

      if (response) {
        setKycData({
          ...(response?.kycDetails ?? {}),
          isNameChecked: false,
          isEmailChecked: false,
          isMobileChecked: false,
          isAddressChecked: false
        })

        setKycEditPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setEditKycLoading(false)
    }
  }

  const handleKycEditPopupClose = () => {
    setKycEditPopupOpen(false)
    setSelectedApplicantId(null)
  }

  const handleKycEditSubmit = async () => {
    try {

      if (!formikRef.current) return

      setKycLinkLoading(true)

      const { values } = formikRef.current

      const currentApplicantData = (values?.applicants ?? []).find((obj) => Number(obj?.id ?? "") === selectedApplicantId)

      const payload = {
        panNo: currentApplicantData?.panNo ?? "",
        emailId: currentApplicantData?.email ?? "",
        investorName: currentApplicantData?.name ?? "",
        isNameChange: kycData?.isNameChecked ? "1" : "0",
        isEmailChange: kycData?.isEmailChecked ? "1" : "0",
        isMobileChange: kycData?.isMobileChecked ? "1" : "0",
        isAddressChange: kycData?.isAddressChecked ? "1" : "0",
        dob: currentApplicantData?.dateOfBirth ?? "",
        applicationId: Number(currentApplicantData?.applicationId ?? "")
      }

      const response = (await dispatch(MfuKycModification(payload)) as unknown as MfuKycModificationResponseBody);

      if (response) {
        setKycEditPopupOpen(false)
        setKycLinkData(response)
        setKycLinkPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setKycLinkLoading(false)
    }
  }

  const handleCloseKycLinkPopup = () => {
    setKycLinkPopupOpen(false)

    history.push('/applications')
  }

  return (
    <>
      {isFamilyListDataLoading && <LinearProgress />}
      {!isFamilyListDataLoading && (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={contributorValues}
            validate={(values: Values) => {
              try {
                validateYupSchema(values, NonIndividualContributorValidationSchema(locale), true, values);
              } catch (e) {
                return yupToFormErrors(e);
              }
            }}
            onSubmit={handleSubmit}
            enableReinitialize={true}>
            {({ handleSubmit, values, setValues }) => (
              <>
                <Grid
                  container
                  rowSpacing={1}
                  //columnSpacing={5}
                  sx={{
                    width: '100%',
                    ml: 0,
                    '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                  }}
                  component="form"
                  noValidate
                  onSubmit={handleSubmit}>
                  {values.applicants.map((applicant, index) => (
                    <React.Fragment key={index}>
                      {/* <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: "-40px", mb: 2 }}>
                        <LoadingButton
                          variant="outlined"
                          onClick={() => {
                            setSelectedApplicantId(Number(applicant?.id ?? ""))
                            handleEditKycClick({
                              applicationId: applicant?.applicationId as string ?? "",
                              applicantId: applicant?.id as string ?? "",
                              panNo: applicant?.panNo ?? ""
                            })
                          }}
                          loading={isEditKycLoading}
                          loadingIndicator={
                            <CircularProgress
                              size={18}
                              sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
                          }
                          sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            color: theme.palette.primary[500],
                            padding: '5px',
                          })}
                        >
                          Edit KYC
                        </LoadingButton>
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.name`}
                          label="Name of Entity *"
                          placeholder="Enter Name of Entity"
                          disabled={applicant.dataFetchedFromKRA || false}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {/* <DatePicker
                      label={'Date of Registration/Incorporation *'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'DD/MM/YYYY'}
                      name={`applicants.${index}.dateOfBirth`}
                      disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    /> */}
                        <TextDatePicker
                          label={'Date of Registration/Incorporation *'}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder={'Enter Net worth as on Date'}
                          name={`applicants.${index}.dateOfBirth`}
                          disabled={applicant.dataFetchedFromKRA || false}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.cityOfIncorporation`}
                          label="Place of Registration/Incorporation *"
                          placeholder="Enter Place of Registration/Incorporation"
                        />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.ckycNo`}
                      label="CKYC No./CKYC Acknowledge No./KIN No "
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                    />
                  </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <SearchableSelect
                          name={`applicants.${index}.countryOfIncorporation`}
                          label="Country of registration/Incorporation *"
                          placeholder="Enter Country of Registration/Incorporation"
                          items={mdmsCountriesList.map((nationality) => ({
                            key: nationality.name,
                            value: nationality.name,
                          }))}
                          searchFieldPlaceholder={'Search Country'}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFSelectField
                          name={`applicants.${index}.investorType`}
                          label="Investor Type *"
                          items={Object.keys(investorTypeMasters).map((investor) => ({
                            key: investorTypeMasters[investor],
                            value: investor,
                          }))}
                          dropdownOptionStyle={{ whiteSpace: 'break-spaces' }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.panNo`}
                          label={`${getUniqueIdentityText(company)?.pan} *`}
                          placeholder={`Enter ${getUniqueIdentityText(company)?.pan}`}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.kraVerified`}
                          label="CVL KRA Verified"
                          placeholder="CVL KRA Verified"
                          disabled={true}
                          value={applicant?.kraVerified?.toLowerCase() === "yes" ? "Yes" : "No"}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.amlCheck`}
                          label="AML Verified"
                          placeholder="AML Verified"
                          disabled={true}
                          value={applicant?.amlCheck ? "Yes" : "No"}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.kraMobileNumber`}
                          label="KRA Mobile Number"
                          placeholder="KRA Mobile Number"
                          // disabled={false}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.kraEmailId`}
                          label="KRA Email Id"
                          placeholder="KRA Email Id"
                          // disabled={false}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          label="Mobile Number"
                          name={`applicants.${index}.mobile`}
                          placeholder=""
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset>legend": {
                                fontSize: { xs: "0.6em", md: "0.81em", lg: "0.8em" }
                              }
                            }
                          }}
                          value={`${applicant?.mobile ?? ""}`}
                          startAdornment={
                            <CountryCodesDropDown
                              name={`applicants.${index}.countryNameAndCode`}
                              value={`${applicant?.countryNameAndCode ?? ""}`}
                              // disabled
                              disabled={isDigitalOnboarding}
                            />
                          }
                          // disabled
                          disabled={isDigitalOnboarding}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          label="Email ID"
                          name={`applicants.${index}.email`}
                          placeholder=""
                          // disabled
                          disabled={isDigitalOnboarding}
                          value={`${applicant?.email ?? ""}`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.gstRegNo`}
                          label={`TIN/GST Registration No`}
                          placeholder={`Enter TIN/GST Registration No.`}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.cin`}
                          label={`CIN/LLPIN`}
                          placeholder={`CIN/LLPIN`}
                          disabled={false}
                        />
                      </Grid>
                      <SubHeading
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        Other Details
                      </SubHeading>
                      <Grid item xs={12} sm={6}>
                        <MFSelectField
                          name={`applicants.${index}.grossAnnualIncome`}
                          label="Gross Annual Income *"
                          items={grossAnnualMasters(locale).map(({ key, value }) => ({
                            key,
                            value
                          }))}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFSelectField
                          name={`applicants.${index}.politicallyExposedPersonStatus`}
                          label="Politically Exposed Person (PEP) Status"
                          items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                        // disabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.netWorth`}
                          label="Net Worth *"
                          placeholder="Enter Net Worth"
                        />
                        {values.applicants[index].netWorth &&
                          !isNaN(Number(values.applicants[index].netWorth)) && (
                            <Typography sx={{ fontSize: 13 }}>
                              {currencyConversion(locale, values.applicants[index].netWorth)}
                            </Typography>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextDatePicker
                          label={'Net Worth as on Date *'}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          maxDate={dayjs().subtract(1, 'day').toDate()}
                          placeholder={'Enter Net worth as on'}
                          name={`applicants.${index}.netWorthDate`}
                        />
                      </Grid>
                    </React.Fragment>
                  ))}

                  {/* UBO Declaration Section */}
                  <Grid item xs={12} my={3}>
                    <Divider sx={(theme: Theme) => ({ borderColor: theme.palette.grey[500] })} />
                  </Grid>
                  <Grid item xs={12}>
                    <SubHeading>UBO Declaration</SubHeading>
                  </Grid>
                  {uboTypesMdms && (
                    <Grid item xs={12}>
                      <Typography ml={{ sm: 2 }} my={2} sx={{ color: 'secondary.main', fontWeight: 500 }}>
                        We hereby declare that:
                      </Typography>
                      {uboTypesMdms.uboType.map((dataValues, ind) => {
                        const declarationValues = dataValues.displayOthers
                          ? dataValues.key === 'none' && values.ubo_declaration_type !== 'none'
                            ? []
                            : [...dataValues.values, { key: `${dataValues.key}_others`, label: 'Others' }]
                          : dataValues.values;
                        return (
                          <Box key={ind} sx={{ ml: { sm: 2 }, mb: 1 }}>
                            <UseRadioGroup
                              name="ubo_declaration_type"
                              items={[{ label: dataValues.displayText, value: dataValues.key }]}
                              onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                                setValues({
                                  ...values,
                                  ubo_declaration_type: value,
                                  ubo_declaration_value: '',
                                  ubo_declaration_others_value: '',
                                });
                              }}
                            />
                            {values.ubo_declaration_type === dataValues.key && dataValues.openEntryField && (
                              <Grid xs={12} sm={6} sx={{ pb: { xs: 1 }, px: '30px' }}>
                                <MFTextField
                                  name="ubo_declaration_value"
                                  placeholder="Please specify the listed company"
                                />
                              </Grid>
                            )}
                            {values.ubo_declaration_type === dataValues.key && !dataValues.openEntryField && declarationValues.length > 0 && (
                              <Box sx={{ pl: 4, pb: 1 }}>
                                <UseRadioGroup
                                  name="ubo_declaration_value"
                                  items={declarationValues.map((typeValue) => ({
                                    label: typeValue.label,
                                    value: typeValue.key,
                                  }))}
                                  sx={{ flexWrap: "wrap", rowGap: "15px" }}
                                />
                                {values.ubo_declaration_value === `${dataValues.key}_others` && (
                                  <Grid sx={{ display: 'inline-block', mt: 1 }}>
                                    <MFTextField
                                      name="ubo_declaration_others_value"
                                      placeholder="Please specify Others"
                                    />
                                  </Grid>
                                )}
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                    </Grid>
                  )}

                  {/* Family Tagging Start */}
                  <Grid item xs={12} my={3}>
                    <Divider sx={(theme: Theme) => ({ borderColor: theme.palette.grey[500] })} />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h2"
                      sx={(theme: Theme) => ({
                        color: theme.palette.text.primary
                      })}
                    >
                      Family Mapping
                    </Typography>
                  </Grid>
                  <Grid item xs={12} mt={3.5}>
                    <UseRadioGroup
                      name="familyMappingType"
                      items={familyMappingOptions}
                      onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                        setValues({
                          ...values,
                          familyId: "",
                          familyName: "",
                          isHeadOfFamily: false,
                          familyMappingType: value
                        })
                      }}
                    />
                  </Grid>
                  {values.familyMappingType === FAMILY_MAPPING_TYPE.EXISTING && (
                    <Grid item xs={12} lg={6} mt={2}>
                      <SearchableSelect
                        name="familyId"
                        label="Existing Family Name*"
                        items={familyListData ?? []}
                        searchFieldPlaceholder={'Search Family'}
                        onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                          const selectedFamilyDetails = (familyListData ?? []).find(obj => obj?.value === value)

                          setValues({
                            ...values,
                            familyId: selectedFamilyDetails?.value ?? "",
                            familyName: selectedFamilyDetails?.key ?? ""
                          })
                        }}
                        value={values.familyId ?? ""}
                      />
                    </Grid>
                  )}
                  {values.familyMappingType === FAMILY_MAPPING_TYPE.NEW && (
                    <>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MFTextField
                          name="familyName"
                          label="Family Name*"
                          placeholder="Enter Family Name"
                          value={values.familyName ?? ""}
                        />
                      </Grid>
                      <Grid item xs={12} lg={6} sx={{ alignContent: "center", mt: 2 }}>
                        <MFCheckbox
                          name="isHeadOfFamily"
                          label="Head of family"
                          sx={(theme: Theme) => ({
                            color: `${theme.palette.text.primary}`,
                            "& :disabled": {
                              color: `${theme.palette.text.secondary}`,
                            }
                          })}
                        />
                      </Grid>
                    </>
                  )}
                  {/* Famiily Tagging End */}
                  <Grid item xs={12} my={2} />
                  <ProceedSaveLater
                    saveLater={() => {
                      setValues({
                        ...values,
                        applicants: values.applicants.map((applicant) => ({
                          ...applicant,
                        })),
                        saveType: 'save for later',
                      });
                    }}
                    saveAndProceed={() => {
                      setValues({
                        ...values,
                        applicants: values.applicants.map((applicant) => ({
                          ...applicant,
                        })),
                        saveType: 'save and proceed',
                      });
                    }}
                    loader={loading}
                    clickedButton={values.saveType}
                  />
                </Grid>
              </>
            )}
          </Formik>
          <KycEditPopup
            open={isKycEditPopupOpen}
            kycData={kycData}
            setKycData={setKycData}
            onClose={handleKycEditPopupClose}
            onSubmit={handleKycEditSubmit}
            isSubmitBtnLoading={kycLinkLoading}
          />
          <KycInfoPopup
            open={kycLinkPopupOpen}
            title={kycLinkData?.message ?? ""}
            subtitle={kycLinkData?.kycOnboardingURL ?? ""}
            copyText={kycLinkData?.kycOnboardingURL ?? ""}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycLinkPopup}
          />
        </>
      )}
    </>
  )
}
